import response from '../../services/mocks/modelCatalog.json';

export const catalogModels = response.models;
export const getCapabilities = model => {
  const known = catalogModels.find(entry => entry.type === model.type && entry.version === model.version);
  if (known) return known.capabilities;
  const type = (model.type || '').toUpperCase();
  if (type === 'YUNET') return ['face', 'alignment'];
  if (type === 'ALIGN') return ['alignment'];
  if (type === 'SSD-DETECTOR') return /^0\.0\.2(?:\.|$)/.test(model.version || '') ? ['face', 'person'] : ['face'];
  if (type === 'YOLO' || type === 'YOLOX') return ['person'];
  if (type === 'HAAR') return ['face'];
  if (type === 'HUMAN-POSE') return ['face', 'person', 'alignment'];
  return ({ AGE: ['age'], AGE_GENDER: ['age', 'gender'], GENDER: ['gender'], GENDER_FULL: ['full-body-gender'], EMOTION: ['emotion'], MTL: ['age', 'gender', 'emotion', 'mtl'] })[type] || [];
};
export const getModelSlot = model => {
  const caps = getCapabilities(model);
  return caps.includes('face') ? 'face' : caps.includes('person') ? 'person' : caps.includes('alignment') ? 'alignment' : null;
};
export const getDetectionState = driver => {
  const models = driver.models || [];
  const face = models.find(model => getModelSlot(model) === 'face');
  const caps = face ? getCapabilities(face) : [];
  return {
    face,
    alignmentIncluded: caps.includes('alignment'),
    personIncluded: caps.includes('person'),
    alignment: models.find(model => getModelSlot(model) === 'alignment'),
    person: models.find(model => getModelSlot(model) === 'person')
  };
};
export const normalizeDetection = models => {
  const state = getDetectionState({ models });
  return models.filter(model => !(state.alignmentIncluded && getModelSlot(model) === 'alignment') && !(state.personIncluded && getModelSlot(model) === 'person'));
};
export const getAudienceValidation = (driver = {}) => {
  const state = getDetectionState(driver || {});
  const errors = [];
  if (!state.face) errors.push('Choose a face detection model.');
  if (state.face && !state.alignmentIncluded && (!state.alignment || !state.alignment.version)) errors.push('Alignment is required for the selected face model.');
  for (const slot of ['face', 'alignment', 'person']) {
    if ((driver.models || []).filter(model => getModelSlot(model) === slot).length > 1) errors.push(`Choose only one ${slot} model.`);
  }
  if ((driver.config || {}).full_body_gender && !state.personIncluded && !state.person) errors.push('Full Body Gender requires person detection.');
  if ((driver.models || []).some(model => !model.type || !model.version)) errors.push('Every selected model needs a type and version.');
  return errors;
};
